import { formatDuration } from './durationFormat';

export const SEED_CRACK_POLL_MS = 5000;

export const SEED_CRACK_STATUS_COLLECTING = 0;
export const SEED_CRACK_STATUS_FEASIBLE = 1;
export const SEED_CRACK_STATUS_CRACKING = 2;
export const SEED_CRACK_STATUS_CRACKED = 3;
export const SEED_CRACK_STATUS_AMBIGUOUS = 4;

export function seedCrackStatusLabelKey(status: number): string {
  switch (status) {
    case SEED_CRACK_STATUS_FEASIBLE: return 'SEED_CRACK_STATUS_FEASIBLE';
    case SEED_CRACK_STATUS_CRACKING: return 'SEED_CRACK_STATUS_CRACKING';
    case SEED_CRACK_STATUS_CRACKED: return 'SEED_CRACK_STATUS_CRACKED';
    case SEED_CRACK_STATUS_AMBIGUOUS: return 'SEED_CRACK_STATUS_AMBIGUOUS';
    default: return 'SEED_CRACK_STATUS_COLLECTING';
  }
}

export function seedCrackStatusIcon(status: number): string {
  switch (status) {
    case SEED_CRACK_STATUS_FEASIBLE: return 'fa-solid fa-magnifying-glass-chart';
    case SEED_CRACK_STATUS_CRACKING: return 'fa-solid fa-gears';
    case SEED_CRACK_STATUS_CRACKED: return 'fa-solid fa-key';
    case SEED_CRACK_STATUS_AMBIGUOUS: return 'fa-solid fa-circle-question';
    default: return 'fa-solid fa-satellite-dish';
  }
}

export function dimensionLabel(t: (key: string, ...args: (string | number)[]) => string, dimension: number): string {
  switch (dimension) {
    case 0: return t('SEED_CRACK_DIM_OVERWORLD');
    case -1: return t('SEED_CRACK_DIM_NETHER');
    case 1: return t('SEED_CRACK_DIM_END');
    default: return t('SEED_CRACK_DIM_OTHER', dimension);
  }
}

export function formatCandidates(n: number): string {
  if (n < 1000) return String(n);
  return new Intl.NumberFormat('en', { notation: 'compact', maximumFractionDigits: 1 }).format(n);
}

export function formatEta(t: (key: string, ...args: (string | number)[]) => string, etaSeconds: number | null | undefined): string {
  const duration = formatDuration(etaSeconds);
  return duration ? `~${duration}` : t('SEED_CRACK_ETA_COLLECTING');
}
